
export enum CustOperationNoteTypeCd {
	DELIVERY_INSTRUCTIONS = 'DeliveryInstructions',
	NOTIFY_ON_ARRIVAL_NOTE = 'NotifyOnArrivalNote',
	OPERATIONS = 'Operations',
	PICKUP_INSTRUCTIONS = 'PickupInstructions'}

